import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryService } from 'src/app/country.service';

@Component({
  selector: 'app-home-routing',
  template: "",
  styles: []
})
export class HomeRoutingComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private countryService: CountryService) { }

  ngOnInit(): void {
    const path = this.route.snapshot.routeConfig.path;
    if (path && (path == 'sg' || path == 'hk' || path == 'au'))
      this.countryService.setCountry(path);
    var r = this.route.snapshot.queryParams.path || "/";
    this.router.navigate([r]);
  }

}
